import { volunteeringRequestHandler } from '../../api/http-client/request-handler'


const TestimonialsListService = {
  getTestimonialsList() {
    return volunteeringRequestHandler.get('comments', {
      params: {
        role: 'mission',
        count: 4,
      },
    })
      .then(({ result }) => result)
  },
}

export default TestimonialsListService
